module.exports = __webpack_public_path__ + "static/user-story-find-assess-niche-games-v2-OberionIO.min-a989eb392b4d42616e15e7f35c0a8403.svg";